import React, { useContext, useEffect, Suspense } from "react";

import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AuthContext from "../store/auth-context";
import axios from "axios";
import gs from "../services/global";

import Login from "../pages/auth/Login";
import OtpVerification from "../pages/auth/OtpVerification";

import SignInNotActiveLoan from "../pages/auth/SignInNotActiveLoan";
import SignInActiveLoan from "../pages/auth/SignInActiveLoan";
import ForgotPassword from "../pages/auth/ForgotPassword";
import CreatePassword from "../pages/auth/CreatePassword";
import EmailSent from "../pages/auth/EmailSent";

import Welcome from "../pages/main/steps/Welcome";
import WelcomeStep1 from "../pages/main/steps/WelcomeStep1";
import WelcomeStep2 from "../pages/main/steps/WelcomeStep2";
import WelcomeStep2In1 from "../pages/main/steps/WelcomeStep2In1";
import WelcomeStep3 from "../pages/main/steps/WelcomeStep3";
import WelcomeStep4 from "../pages/main/steps/WelcomeStep4";

import AlmostDone from "../pages/main/AlmostDone";
import PreScoring from "../pages/main/PreScoring";
import Bank from "../pages/main/Bank";
import CardDetail from "../pages/main/CardDetail";
import Congratulations from "../pages/main/Congratulations";
import DirectDebit from "../pages/main/DirectDebit";
import FinalizeLoanDetail from "../pages/main/FinalizeLoanDetail";
import YourAllSet from "../pages/main/YourAllSet";

import Authentication from "../pages/main/Authentication";
import Password from "../pages/main/Password";

import Failure from "../pages/main/Failure";
import PageNotFound from "../pages/main/PageNotFound";
import Rejected from "../pages/main/Rejected";
import Disabled from "../pages/main/Disabled";

const RouteStack = () => {
  const authCtx = useContext(AuthContext); // eslint-disable-next-line

  useEffect(() => {
    /* Loader Starts */
    gs.showLoader(true);
    /* Loader Ends */

    /* offer API */
    axios
      .get("/offer")
      .then((response) => {
        const result = response?.data;
        authCtx.offerDataFunc(result);

        /* Loader Starts */
        gs.showLoader(false);
        /* Loader Ends */
      })
      .catch(() => {

        /* Loader Starts */
        gs.showLoader(false);
        /* Loader Ends */
      });
    /* offer API end */
  }, []);

  return (
    <>
      <Suspense fallback={<span>Loading...</span>}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/:instanceParamsId" element={<Login />} />
          <Route path="/verify-phone" element={<OtpVerification />} />

          <Route
            path="/signin-email-noactive-loan"
            element={<SignInNotActiveLoan />}
          />
          <Route
            path="/signin-email-active-loan"
            element={<SignInActiveLoan />}
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/create-a-password" element={<CreatePassword />} />
          <Route path="/email-sent" element={<EmailSent />} />
          {/* Auth Pages ends here */}

          {/* Info Pages starts here */}
          <Route index path="/welcome" element={<Welcome />} />

          <Route path="/login" element={<Authentication />} />
          <Route path="/setup-password" element={<Password />} />

          <Route path="/personal-information" element={<WelcomeStep1 />} />
          <Route path="/address" element={<WelcomeStep2 />} />
          <Route path="/confirm-address" element={<WelcomeStep2In1 />} />
          <Route path="/questionnaire" element={<WelcomeStep3 />} />
          <Route path="/bank-details" element={<WelcomeStep4 />} />
          <Route path="/bank" element={<Bank />} />
          {/* Info Pages ends here */}

          {/* Static Pages starts here */}
          <Route path="/almost-done" element={<AlmostDone />} />
          <Route path="/pre-scoring" element={<PreScoring />} />
          <Route path="/approved" element={<Congratulations />} />
          <Route path="/verify-card" element={<CardDetail />} />
          <Route path="/direct-debit" element={<DirectDebit />} />
          <Route path="/sign-contract" element={<FinalizeLoanDetail />} />
          <Route path="/success" element={<YourAllSet />} />
          <Route path="/failure" element={<Failure />} />
          <Route path="/rejected" element={<Rejected />} />
          <Route path="/disabled" element={<Disabled />} />
          {/* Static Pages ends here */}

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Suspense>

      <ToastContainer className="comm-toaster" />
    </>
  );
};

export default RouteStack;
